module.exports = __webpack_public_path__ + "static/media/bg_left@2x.d6ad1687.png";